export const BRAND_NAME = 'PlayBhai';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'playbhai.in';
export const PROVIDER_ID = 'BetFair';
